import { TimeManagementListItem } from '@myapp/contract'
import { TIME_ENTRY_CATEGORY_COLOR, getTimeEntryCategoryLabel } from '../../../entities/time-entry'

interface Props {
  entry: TimeManagementListItem
  isAllDay?: boolean
  onClick?: (id: number) => void
}

export const WeekTimeManagementPill = ({ entry, isAllDay, onClick }: Props) => {
  if (isAllDay) {
    return (
      <div
        className="flex flex-1 flex-col items-center justify-center rounded px-1 py-1 text-[11px] font-semibold leading-tight text-white cursor-pointer min-h-[48px]"
        style={{ backgroundColor: TIME_ENTRY_CATEGORY_COLOR }}
        onClick={(e) => { e.stopPropagation(); onClick?.(entry.id) }}
      >
      
        <span className="text-center leading-tight">{getTimeEntryCategoryLabel(entry.category)}</span>
      </div>
    )
  }

  return (
    <div
      className="flex items-center rounded px-1 py-0.5 text-[11px] leading-tight text-white truncate cursor-pointer"
      style={{ backgroundColor: TIME_ENTRY_CATEGORY_COLOR }}
      onClick={(e) => { e.stopPropagation(); onClick?.(entry.id) }}
    >
      <span className="truncate">{getTimeEntryCategoryLabel(entry.category)}</span>
    </div>
  )
}
